import React, { Component, SyntheticEvent } from 'react';

import './modal.css';

interface Props {
    visible: boolean;
    onClose: (e?: SyntheticEvent) => void;
    title?: string;
    className?: string;
    renderHeader?: () => JSX.Element;
    renderBody?: () => JSX.Element;
    renderButtons?: () => JSX.Element;
    onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
}

class Modal extends Component<Props> {
    public render() {
        const { visible, title, renderHeader, onClose, renderBody, renderButtons, className } = this.props;
        const style = {
            display: visible ? 'block' : 'none' };
        return (
            <div className={`modal fadein${visible ? ' show' : ''}`} tabIndex={-1} role="dialog" style={style} aria-hidden="true">
                <div className="modal-layer" onClick={onClose} />
                <div className={`modal-dialog ${className}`}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" onClick={onClose}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
                            {title && <h4 className="modal-title">{title}</h4>}
                            {renderHeader && renderHeader()}
                        </div>
                        {this.props.onSubmit  ? (
                            <form onSubmit={this.props.onSubmit}>
                                {renderBody && (
                                    <div className="modal-body">
                                        {renderBody()}
                                    </div>
                                )}

                                {renderButtons && (
                                    <div className="modal-footer">
                                        {renderButtons()}
                                    </div>
                                )}
                            </form>
                        ) : (
                            <>
                                {renderBody && (
                                    <div className="modal-body">
                                        {renderBody()}
                                    </div>
                                )}

                                {renderButtons && (
                                    <div className="modal-footer">
                                        {renderButtons()}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.tsx